import React from "react";
import classes from "./Layout.module.css";

import Sidebar from "./../Sidebar/Sidebar";
import Toolbar from "../Toolbar/Toolbar";
import { withRouter } from "react-router-dom";

const Layout = (props) => {
	return (
		<div className={classes.Layout}>
			<div className={classes.Sidebar}>
				<Sidebar />
			</div>
			<div className={classes.Main}>
				<Toolbar />
				<div className={classes.Scrolling}>{props.children}</div>
			</div>
		</div>
	);
};

let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);
export default withRouter(Layout);
